// extracted by mini-css-extract-plugin
module.exports = {"button":"RemoveSegment-module__button___he6sA","icon":"RemoveSegment-module__icon___MACNB"};